<template>
  <section>
    <v-container fluid class="px-0">
      <!-- Header -->
      <v-row align="center" justify="space-between">
        <v-col cols="auto" class="py-1 px-6 font-weight-bold">
          {{ $t("new booking") }}
        </v-col>
        <v-col cols="auto" class="py-1">
          <v-btn depressed @click="save" :min-width="90" :loading="saveIsLoading || heCanIsLoading"
            :disabled="!(valid && heCan)" class="my-2 mx-2 rounded-lg white--text" :height="37" color="green1">{{
              $t("save") }}</v-btn>
        </v-col>
      </v-row>
      <!-- End Of Header -->
      <!-- Form -->
      <v-form ref="form" v-model="valid" class="px-3">
        <v-card class="backgroundW shadow pa-5 mt-3 overflow-hidden">
          <v-row v-if="!pageData.isLoading" justify="space-around">
            <v-col cols="12" md="3" class="px-1">
              <div class="subtitle-2 mb-5 gray8--text">
                {{ $t("customer details") | capitalize }}
              </div>
              <label class="mb-2 d-inline-block">{{ $t("customer name") }}
                <span v-if="form.customer_name">
                  {{ " : " + form.customer_name }}
                </span>
              </label>
              <label class="mb-4 d-inline-block caption" style="width: 100%;">{{ $t("wallet points") }}
                <span>
                  {{ " : " + customerPointsBalance }}
                </span>
              </label>
              <v-col cols="12" class="position-relative pa-0">
                <GenericInput :dense="true" type="select" :lookups="barber_customers" paddingX="px-0"
                  :value="form.customer_mobile" @input="form.customer_mobile = $event" label="customer mobile"
                  :multi="false" :required="true" selected_label="mobile" :disabled="false" selected_prop="mobile"
                  :onChange="onChangeCustomerMobile" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]">
                </GenericInput>

                <v-btn icon fab x-small class="lockupsAddButton" @click="addCustomerDialog = true" color="success">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <!-- <GenericInput :dense="true" paddingX="px-0" type="text" name="customer_name" :value="form.customer_name"
                        @input="form.customer_name = $event" label="customer name" :required="true"
                        :isLoading="pageData.isLoading" :cols="[12, 12, 12]">
                     </GenericInput> -->
              <GenericInput :dense="true" paddingX="px-0" type="textarea" name="notes" :value="form.notes"
                @input="form.notes = $event" label="notes" :required="false" :isLoading="pageData.isLoading"
                :cols="[12, 12, 12]">
              </GenericInput>
            </v-col>

            <v-col cols="12" sm="auto">
              <v-divider vertical />
            </v-col>
            <v-col cols="12" md="5" class="px-1">
              <div class="subtitle-2 mb-5 gray8--text">
                {{ $t("select services") | capitalize }}
              </div>
              <v-row>
                <v-col cols="12" v-if="barber">
                  <v-sheet color="light" class="pa-3 rounded-lg">
                    <v-row align="center">
                      <v-col cols="12" class="caption pb-0 font-weight-bold gray3--text">
                        {{ $t("barber") | capitalize }}
                      </v-col>
                      <v-col cols="auto" class="caption gray3--text" v-lazy-container="{ selector: 'img' }">
                        <img :height="45" :width="45" :data-src="$store.state.endpointURL + barber.image"
                          class="d-block mi-start-auto rounded-circle" :alt="barber.name" />
                      </v-col>
                      <v-col cols="auto" class="caption gray3--text">
                        {{ barber.name }}
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
                <v-col cols="12" md="4" class="px-0">
                  <v-tabs dense show-arrows :centered="!(
                    $vuetify.breakpoint.name === 'xl' ||
                    $vuetify.breakpoint.name === 'lg' ||
                    $vuetify.breakpoint.name === 'md'
                  )
                    " :vertical="$vuetify.breakpoint.name === 'xl' ||
                      $vuetify.breakpoint.name === 'lg' ||
                      $vuetify.breakpoint.name === 'md'
                      ">
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab dense active-class="activeItem" class="font-weight-bold" :value="category.id"
                      @click="category_id = category.id" v-for="category in categories" :key="category.id">
                      <div class="d-flex w-100 justify-between align-center">
                        <div class="d-flex align-center">
                          <div v-lazy-container="{ selector: 'img' }" class="d-none d-sm-block"
                            :key="`category_img_${category.id}`"></div>
                          <div class="caption mx-2">
                            {{ category.name | capitalize }}
                          </div>
                        </div>
                      </div>
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="12" md="8" class="px-1">
                  <div class="radio_group my-0 rounded-0 mb-2 pa-2" v-for="service in filteredServices"
                    :key="service.id" :class="{
                      blue1: selected_services.some(
                        (selectedService) => selectedService.id == service.id
                      ),
                      white: !selected_services.some(
                        (selectedService) => selectedService.id == service.id
                      ),
                    }">
                    <v-checkbox hideDetails :value="service" :color="selected_services.some(
                      (selectedService) => selectedService.id == service.id
                    )
                      ? 'white'
                      : 'blue1'
                      " v-model="selected_services">
                      <template v-slot:label>
                        <v-row class="mx-0 caption d-flex justify-space-between" :class="{
                          'white--text': selected_services.some(
                            (selectedService) =>
                              selectedService.id == service.id
                          ),
                        }">
                          <v-col cols="auto" class="mx-0">{{ service.name | capitalize }}
                            <v-tooltip v-if="service.description" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon :class="{
                                  'white--text': selected_services.some(
                                    (selectedService) =>
                                      selectedService.id == service.id
                                  ),
                                }" size="19" v-bind="attrs" v-on="on">mdi-information</v-icon>
                              </template>
                              <span>{{ service.description }}</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="auto" class="mx-0 text-end">{{
                            service.price_with_vat | float
                          }}</v-col>
                        </v-row>
                      </template>
                    </v-checkbox>
                  </div>
                  <v-alert color="error" outlined dense v-if="filteredServices.length == 0" :value="true">
                    <small>{{
                      $t("ops, no services here") | capitalize
                    }}</small>
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="auto">
              <v-divider vertical />
            </v-col>

            <v-col cols="12" md="6" lg="3" class="px-1">
              <div class="subtitle-2 mb-5 gray8--text">
                {{ $t("services details and totals") | capitalize }}
              </div>
              <v-sheet color="light" class="pa-3 rounded-lg">
                <v-row justify="space-between">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ barber_booking_date }}
                  </v-col>
                  <v-col cols="auto" class="caption gray3--text">
                    {{ barber_booking_date }}
                  </v-col>
                </v-row>
                <v-row justify="space-between" v-for="(service, index) in selected_services" :key="index">
                  <v-col cols="auto" class="caption black--text">
                    {{ service.name | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption font-weight-bold black--text">
                    {{ service.price_with_vat | float }}
                  </v-col>
                  <v-col cols="12" class="py-0 px-5"
                    v-if="selected_services.length > index + 1"><v-divider></v-divider></v-col>
                </v-row>
              </v-sheet>

              <!-- Voucher and Points Section -->
              <v-sheet color="light" class="pa-3 shadow mt-3 rounded-lg" v-if="false">
                <div class="subtitle-2 mb-3 gray8--text">
                  {{ $t("discounts and deductions") | capitalize }}
                </div>
                <v-btn-toggle v-model="selectedDiscountType" mandatory dense class="mb-3" tile
                  color="light-blue darken-4">
                  <v-btn small value="points" depressed width="90">
                    <v-icon left small :color="selectedDiscountType === 'points'
                      ? 'light-blue darken-4'
                      : 'black'
                      ">mdi-star-circle</v-icon>{{ $t("points") }}
                  </v-btn>
                  <v-btn small value="coupon" depressed width="90">
                    <v-icon left small :color="selectedDiscountType === 'coupon'
                      ? 'light-blue darken-4'
                      : 'black'
                      ">mdi-ticket-percent</v-icon>{{ $t("coupon") }}
                  </v-btn>
                </v-btn-toggle>

                <!-- coupon Input -->
                <v-row class="mb-2" align="center" v-if="selectedDiscountType === 'coupon'">
                  <v-col cols="8" class="py-1">
                    <GenericInput paddingX="px-0 mt-3" type="text" name="coupon_code" :value="form.coupon_code"
                      @input="form.coupon_code = $event" label="coupon code" :required="false"
                      :isLoading="pageData.isLoading" :clearable="true" :dense="true"
                      :disabled="!selected_services?.length" :cols="[12, 12, 12]">
                    </GenericInput>
                  </v-col>
                  <v-col cols="4" class="py-1 mt-2">
                    <v-btn small color="primary" depressed height="36" @click="applyCoupon" :loading="couponIsLoading"
                      :disabled="!form.coupon_code ||
                        form.coupon_code.trim() === '' ||
                        selected_services.length === 0
                        ">
                      {{ $t("apply") }}
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Points Input -->
                <v-row class="mb-2" align="center" v-if="selectedDiscountType === 'points'">
                  <v-col cols="12" class="py-1 mt-2">
                    <div class="caption primary--text mb-1">
                      {{ $t("available points") | capitalize }}:
                      <span class="font-weight-bold">{{
                        customerPointsBalance
                      }}</span>

                      <v-tooltip bottom v-if="customerPointsBalance > 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon size="16" v-bind="attrs" v-on="on" class="ml-1">mdi-information</v-icon>
                        </template>
                        <span>{{
                          $t(
                            "points can be used to reduce the total price before VAT"
                          )
                        }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="8" class="py-1">
                    <v-autocomplete v-if="validationMinPointsToRedeem" v-model="form.points_to_use"
                      :items="convertToMultiples(customerPointsBalance, 10)" :label="$t('points to use')" outlined dense
                      item-text="name" item-value="id" />

                    <div class="caption blue5--text mt-1">
                      {{ $t("minimum bill value to use points") | capitalize }}:
                      <span class="font-weight-bold">{{ minAmountToRedeemPoints | float }}
                        {{ $t("sar") }}</span>
                    </div>
                  </v-col>
                </v-row>

                <!-- Applied Discounts Display -->
                <v-row v-if="
                  form.coupon_discount > 0 &&
                  selectedDiscountType === 'coupon'
                " class="mb-1">
                  <v-col cols="8" class="caption gray3--text">
                    {{ $t("coupon discount") | capitalize }}
                  </v-col>
                  <v-col cols="4" class="caption font-weight-bold green--text text-right">
                    -{{ form.coupon_discount | float }}
                  </v-col>
                </v-row>

                <v-row v-if="
                  form.points_discount > 0 &&
                  selectedDiscountType === 'points'
                " class="mb-1">
                  <v-col cols="8" class="caption gray3--text">
                    {{ $t("points discount") | capitalize }}
                  </v-col>
                  <v-col cols="4" class="caption font-weight-bold green--text text-right">
                    -{{ form.points_discount | float }}
                  </v-col>
                </v-row>

                <!-- Clear Discounts Button -->
                <v-row v-if="form.coupon_discount > 0 || form.points_discount > 0" class="mt-3">
                  <v-col cols="12" class="text-center">
                    <v-btn small outlined color="error" @click="clearDiscounts">
                      {{ $t("clear all discounts") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>

              <v-sheet color="light" class="pa-3 shadow mt-5 rounded-lg">
                <v-row justify="space-between">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ $t("total services") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption gray3--text">
                    {{ selected_services.length }}
                  </v-col>
                </v-row>
                <v-row justify="space-between">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ $t("total before vat") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption gray3--text">
                    {{ totals.price_without_vat | float }}
                  </v-col>
                </v-row>
                <v-row justify="space-between" v-if="totals.total_discounts > 0">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ $t("total discounts") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption font-weight-bold green--text">
                    -{{ totals.total_discounts | float }}
                  </v-col>
                </v-row>
                <v-row justify="space-between" v-if="
                  totals.subtotal_after_discounts > 0 &&
                  totals.total_discounts > 0
                ">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ $t("total after discounts") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption font-weight-bold green--text">
                    {{ totals.subtotal_after_discounts | float }}
                  </v-col>
                </v-row>
                <v-row justify="space-between">
                  <v-col cols="auto" class="caption gray3--text">
                    {{ $t("total vat") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption gray3--text">
                    {{ totals.vat_after_discounts | float }}
                  </v-col>
                </v-row>
                <v-row justify="space-between">
                  <v-col cols="auto" class="caption font-weight-bold gray3--text">
                    {{ $t("total with vat") | capitalize }}
                  </v-col>
                  <v-col cols="auto" class="caption font-weight-bold gray3--text">
                    {{ totals.final_total | float }}
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>

          <div class="my-16">
            <AnimatedLoading :height="100" :isLoading="pageData.isLoading" />
          </div>
        </v-card>
      </v-form>
      <!-- End of Form -->

      <AddLockupsDialog entityName="customer" endPoint="add_customer" :enablePhone="true" :enableBookingOption="true"
        :sendAsRequest="true" :callBackMethod="callBackMethodCustomer" :dialog="addCustomerDialog" :closeMethod="() => {
          addCustomerDialog = false;
        }
          " :saveMethod="saveCustomer" />
    </v-container>
  </section>
</template>

<script>
import AnimatedLoading from "@/components/AnimatedLoading.vue";
import GenericInput from "@/components/GenericInput.vue";
import AddLockupsDialog from "@/components/modals/AddLockupsDialog.vue";

export default {
  name: "BarberBookingControl",
  data: () => ({
    pageData: {
      screen_code: "10-004",
      url: null,
      controlRoute: "/barber/barber_booking/",
      entityName: null,
      main: null,
      category: null,
      isLoading: true,
      isEdit: false,
      editIsLoading: false,
    },
    valid: false,
    addCustomerDialog: false,
    form: {
      customer_id: null,
      customer_name: null,
      customer_mobile: null,
      notes: null,
      branch_name: null,
      branch_id: null,
      branch_address: null,
      coupon_code: null,
      points_to_use: 0,
      coupon_discount: 0,
      points_discount: 0,
    },
    queryParam: "?",
    heCan: false,
    saveIsLoading: false,
    heCanIsLoading: false,
    barber: {
      image: null,
      name: null,
    },
    barber_booking_date: null,
    barber_id: null,
    start_time: null,
    customer_search: null,
    category_id: null,
    selected_customer: null,
    selected_services: [],
    // lockups
    services: [],
    categories: [],
    barber_customers: [],
    branches: [],
    couponIsLoading: false,
    customerPointsBalance: 0,
    selectedDiscountType: "points",
    discount_type: null,
  }),
  components: { GenericInput, AnimatedLoading, AddLockupsDialog },
  computed: {
    filteredServices() {
      if (this.services.length > 0 && this.category_id) {
        return this.services.filter(
          (service) => service.category_id === this.category_id
        );
      } else {
        return [];
      }
    },
    totals() {
      const discountValue =
        (this.form.coupon_discount || 0) + (this.form.points_discount || 0);
      const discount = {
        type: this.discount_type,
        value: discountValue,
      };

      const calculation = this.$global.CalculateCartTotals(
        this.selected_services,
        discount
      );
      if (this.selected_services) {
        return {
          price_without_vat: calculation.summary.subtotalWithoutVat,
          vat: calculation.summary.totalVat,
          price_with_vat:
            calculation.summary.subtotalWithoutVat +
            calculation.summary.totalVat,
          total_discounts: calculation.summary.totalDiscount,
          subtotal_after_discounts: calculation.summary.subtotalAfterDiscount,
          vat_after_discounts: calculation.summary.totalVat,
          final_total: calculation.summary.grandTotal,
        };
      } else {
        return {
          price: 0,
          vat: 0,
          price_with_vat: 0,
          total_discounts: 0,
          subtotal_after_discounts: 0,
          vat_after_discounts: 0,
          final_total: 0,
        };
      }
    },
    minAmountToRedeemPoints() {
      return Number(
        this.$store.state.userData.settings?.min_amount_invoice || 0
      );
    },
    pricePerPoint() {
      return Number(
        this.$store.state.userData.settings?.points_count_sar_usage || 0
      );
    },
    validationMinPointsToRedeem() {
      return this.totals?.price_with_vat >= this.minAmountToRedeemPoints;
    },
    convertToMultiples() {
      return (dividend, divisor) =>
        Array.from({ length: Math.floor(dividend / divisor) }, (_, i) => {
          let amount = (i + 1) * divisor;
          return {
            id: amount,
            name: amount,
            disabled:
              amount / this.pricePerPoint > this.totals?.price || amount > 100,
          };
        });
    },
  },
  watch: {
    "form.points_to_use"(val) {
      if (val > 0) {
        // Ensure exclusivity with coupon
        if (this.form.coupon_discount > 0 || this.form.coupon_code) {
          this.form.coupon_discount = 0;
          this.form.coupon_code = null;
        }
        this.form.points_discount = val / this.pricePerPoint;
        this.discount_type = "fixed";
      } else {
        this.form.points_discount = 0;
        this.discount_type = null;
      }
    },
    selected_customer(val) {
      switch (typeof this.selected_customer) {
        case "object":
          this.form.customer_id = val ? this.selected_customer.id : null;
          this.form.customer_name = val ? this.selected_customer.name : null;
          this.form.customer_mobile = val
            ? this.selected_customer.mobile
            : null;
          this.customer_search = null;
          break;

        case "string":
          this.form.customer_id = 0;
          this.form.customer_name = null;
          this.customer_search = null;
          this.form.customer_mobile = this.selected_customer ?? null;
          break;

        default:
          this.form.customer_id = 0;
          this.form.customer_name = null;
          this.form.customer_mobile = null;
          this.customer_search = null;
          break;
      }
    },
    selected_services() {
      if (this.selected_services.length > 0) this.checkIFHeCan();
      else this.heCan = false;
    },
    selectedDiscountType() {
      this.clearDiscounts();
    },
  },
  mounted() {
    this.pageMainData();
    this.queryParams();
    this.getData();
  },
  methods: {
    callBackMethodCustomer(data) {
      this.form.customer_id = data.id;
      this.customerPointsBalance = 0;
    },
    queryParams() {
      this.barber_id = +this.$store.state.activeScreen.queryParams.barber_id;
      this.start_time = +this.$store.state.activeScreen.queryParams.start_time;
      this.barber_booking_date =
        this.$store.state.activeScreen.queryParams.barber_booking_date;
      this.queryParam = this.$store.state.activeScreen.requestParam || "";
    },
    pageMainData() {
      this.pageData.main = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).main_title;
      this.pageData.category = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).cat_title;
      this.pageData.url = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).url;
      this.pageData.entityName = this.pageData.entityName = this.$route.params
        .id
        ? this.$i18n.t("edit") + " " + this.$i18n.t("booking")
        : this.$i18n.t("add") + " " + this.$i18n.t("booking");
    },
    getData() {
      if (this.barber_id && this.start_time && this.barber_booking_date) {
        if (this.$global.CheckAction(this.pageData.screen_code, 2)) {
          this.pageData.isLoading = true;
          this.categories = [];
          this.services = [];
          this.$api
            .GET_METHOD(`barber_booking/create${this.queryParam}`)
            .then((response) => {
              this.pageData.isLoading = false;
              if (response.check) {
                this.barber = response.data.barber || Object;
                this.categories = response.data.categorys || [];
                this.services = response.data.services || [];
                this.barber_customers = response.data.barber_customers || [];
                this.category_id =
                  this.categories.length > 0
                    ? this.categories[0].id
                    : null;
                this.form.branch_id =
                  response.data.branchs.length > 0
                    ? response.data.branchs[0].id
                    : null;
                this.form.branch_name =
                  response.data.branchs.length > 0
                    ? response.data.branchs[0].name
                    : null;
                this.form.branch_address =
                  response.data.branchs.length > 0
                    ? response.data.branchs[0].address
                    : null;
                this.branches = response.data.branchs;
              } else {
                this.$router.push(this.pageData.url);
              }
            });
        } else {
          this.$router.push(this.pageData.url);
          this.$store.state.snackbarTitle =
            "make sure you have permission to add";
          this.$store.state.snackbarType = "error";
          this.$store.state.showSnackbar = true;
        }
      } else {
        this.$router.push(this.pageData.url);
        this.$store.state.snackbarTitle =
          "make sure to select start time , date and barber";
        this.$store.state.snackbarType = "error";
        this.$store.state.showSnackbar = true;
      }
    },
    save() {
      const IDS = this.selected_services.map((service) => service.id);
      const requestBody = {
        services: IDS,
        branch_id: this.form.branch_id,
        booking_date: this.barber_booking_date,
        start_time: +this.start_time,
        barber_id: +this.barber_id,
        coupon_code: this.form.coupon_code,
        points: this.form.points_to_use,
        customer_mobile: this.form.customer_mobile,
        customer_id: this.form.customer_id,
        notes: this.form.notes,
        platform: "web",
      };

      // remove points and coupon code if not used
      !this.form.points_to_use && delete requestBody.points;
      !this.form.coupon_code && delete requestBody.coupon_code;

      if (this.$refs.form.validate()) {
        this.saveIsLoading = true;
        this.$api
          .POST_METHOD(`barber_booking`, requestBody)
          .then((response) => {
            this.saveIsLoading = false;
            if (response.check) {
              this.$router.push(
                this.pageData.url +
                (this.$store.state.prevScreen.requestParam || "")
              );
            }
          });
      }
    },
    checkIFHeCan() {
      this.heCanIsLoading = true;
      const IDS = this.selected_services.map((service) => service.id);
      const requestBody = {
        barber_booking_date: this.barber_booking_date,
        barber_id: +this.barber_id,
        services: IDS,
        start_time: +this.start_time,
      };
      this.$api
        .POST_METHOD(`check_booking_services_blocks`, requestBody)
        .then((res) => {
          this.heCanIsLoading = false;
          this.heCan = res.check;
        });
    },
    deleteMethod(status) {
      if (status == true) {
        this.pageData.isLoading = true;
        this.$api
          .POST_METHOD(`barber/${this.form.id}`, { _method: "delete" })
          .then(() => {
            this.$router.push(
              this.pageData.url +
              (this.$store.state.prevScreen.requestParam || "")
            );
            this.pageData.isLoading = false;
          });
      }
    },
    saveCustomer(customer) {
      console.log("customer", customer);
      customer.mobile = customer.phone;
      this.barber_customers.push(customer);
      this.form.customer_id = customer.id;
      this.form.customer_name = customer.name;
      this.form.customer_mobile = customer.phone;
      this.addCustomerDialog = false;
    },
    applyCoupon() {
      if (this.form.points_discount > 0 || this.form.points_to_use > 0) {
        this.form.points_discount = 0;
        this.form.points_to_use = 0;
      }
      this.couponIsLoading = true;
      const couponCode = this.form.coupon_code;
      this.$api
        .GET_METHOD(`get_coupon_data/${couponCode}`)
        .then((response) => {
          this.couponIsLoading = false;
          if (response.check) {
            const coupon = response.data;
            const subtotal = this.totals.price_without_vat;
            let discountAmount = 0;
            if (coupon.discount_type === 1) {
              discountAmount = coupon.discount;
              this.discount_type = "fixed";
            } else if (coupon.discount_type === 2) {
              discountAmount = subtotal * (coupon.discount / 100);
              this.discount_type = "percent";
            }
            if (discountAmount > subtotal) {
              discountAmount = subtotal;
            }
            this.form.coupon_discount = discountAmount;
            this.$store.state.snackbarTitle = this.$i18n.t(
              "coupon applied successfully"
            );
            this.$store.state.snackbarType = "success";
            this.$store.state.showSnackbar = true;
          } else {
            this.form.coupon_discount = 0;
          }
        })
        .catch(() => {
          this.couponIsLoading = false;
          this.form.coupon_discount = 0;
        });
    },
    applyPoints() {
      // Ensure exclusivity with coupon
      if (this.form.coupon_discount > 0 || this.form.coupon_code) {
        this.form.coupon_discount = 0;
        this.form.coupon_code = null;
      }
      // Validate minimum points threshold
      if (
        !this.form.points_to_use ||
        this.form.points_to_use < this.minAmountToRedeemPoints
      ) {
        this.$store.state.snackbarTitle = this.$i18n.t(
          "minimum points threshold not met"
        );
        this.$store.state.snackbarType = "error";
        this.$store.state.showSnackbar = true;
        return;
      }
      this.form.points_discount = this.form.points_to_use / this.pricePerPoint;
      this.discount_type = "fixed";
      this.$store.state.snackbarTitle = this.$i18n.t(
        "points applied successfully"
      );
      this.$store.state.snackbarType = "success";
      this.$store.state.showSnackbar = true;
    },
    clearDiscounts() {
      this.form.coupon_code = null;
      this.form.points_to_use = 0;
      this.form.coupon_discount = 0;
      this.form.points_discount = 0;
      this.discount_type = null;
    },
    onChangeCustomerMobile(value) {
         let customerData = this.barber_customers.find(customer => customer.mobile === value);
         this.form.customer_name = customerData?.name;
         this.form.customer_id = customerData?.id;
         this.customerPointsBalance = customerData?.wallet_points || 0;
      },
  },
};
</script>

<style lang="scss" scoped>
.activeItem {
  // border-right: 4px solid blue;
  background-color: #3163ff !important;
  color: #fff !important;

  .primary--text {
    color: #fff !important;
  }

  &::after {
    width: 5.22px;
    height: 10px;
    content: "";
    right: unset;
    left: 0;
    position: absolute;
    background-color: #3163ff !important;
    border-radius: 4px 0px 0px 3px;
  }
}

.radio_group {
  background-color: #f4f4f4 !important;
  border: 1px solid #e0e0e0 !important;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 8px;
}
</style>
